import { render } from "./MyOfferPriceList.vue?vue&type=template&id=39d98498&scoped=true&ts=true&lang=pug"
import script from "./MyOfferPriceList.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyOfferPriceList.vue?vue&type=script&lang=ts&setup=true"

import "./MyOfferPriceList.vue?vue&type=style&index=0&id=39d98498&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d98498"]])

export default __exports__